module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('b', [_vm._v("Version")]), _vm._v(" " + _vm._s(_vm.version) + "\n  ")]), _vm._v("\n  " + _vm._s(_vm.footer) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c33c991e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 478
// module chunks = 11